module.exports = __webpack_public_path__ + "static/media/metal-fab.f1df7d7e.jpg";